import { Injectable } from '@angular/core';
import { LocalForageStrategy } from '@dch/entity-manager/lib/storage/strategies/local-forage.strategy';
import {
  createRemoteLogger,
  IRemoteLoggerConfiguration,
  IRemoteLog,
  LogLevel,
  IRemoteLogger,
} from '@dch/monitoring';
import EntityManagerProviderStrategy from '@dch/monitoring/dist/lib/http/entityManagerProviderStrategy';

export const REMOTE_LOGGER_CONFIGURATION: IRemoteLoggerConfiguration = {
  REMOTE_LOGS_ENABLED: true,
  DELAY_BEFORE_SENDING: 30 * 1000,
  REMOTE_LOGS_SIZE: 15,
  onErrorCallback: (errorMessage: string) => {
    console.error(errorMessage);
  },
  httpProvider: EntityManagerProviderStrategy(),
  storageProvider: new LocalForageStrategy(),
};

@Injectable()
export class RemoteLoggerService {
  remoteLogger: IRemoteLogger;

  constructor() {
    this.remoteLogger = createRemoteLogger(REMOTE_LOGGER_CONFIGURATION);
    this.remoteLogger.initializeBatchLogger();
  }

  logError(message: string, context?: any) {
    this.remoteLogger.addLog(
      this.formatLogData(LogLevel.ERROR, message, context)
    );
  }

  logErrorImmediately(message: string, context?: any) {
    this.remoteLogger.sendLogs([
      this.formatLogData(LogLevel.ERROR, message, context),
    ]);
  }

  private formatLogData(level: LogLevel, message: string, error?: any) {
    const log: IRemoteLog = {
      level,
      timestamp: Date.now(),
      sessionId: '',
      spanId: '',
      context: 'myBill',
      message: error ? message.concat(' ', JSON.stringify(error)) : message,
    };
    return log;
  }
}
